import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { api } from '../services/api';
import LazyImage from '../components/LazyImage';
import { RotatingLines } from 'react-loader-spinner';
import { getImageUrl } from '../utils/imageUtils';

const Container = styled.div`
  max-width: ${({ theme }) => theme.breakpoints.large};
  margin: 0 auto;
  padding: 2rem;
`;

const HeaderSection = styled.div`
  text-align: center;
  margin-bottom: 4rem;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: ${({ theme }) => theme.colors.secondary};
  margin-bottom: 1rem;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
`;

const PostCard = styled.div`
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.shadows.small};
  display: flex;
  flex-direction: column;
  transition: transform 0.2s;
  
  &:hover {
    transform: translateY(-5px);
  }
`;

const ImageContainer = styled.div`
  height: 200px;
`;

const Content = styled.div`
  padding: 1.5rem;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const PostTitle = styled.h3`
  margin-bottom: 0.5rem;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.text};
`;

const DateText = styled.span`
  font-size: 0.8rem;
  color: #888;
  margin-bottom: 1rem;
  display: block;
`;

const News = () => {
  const [header, setHeader] = useState(null);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.get('/news/header'), api.get('/news/posts')])
      .then(([headerRes, postsRes]) => {
        setHeader(headerRes);
        setPosts(postsRes);
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div style={{display:'flex', justifyContent:'center', marginTop:'50px', minHeight:'100vh'}}>
      <RotatingLines strokeColor="grey" width="50" />
    </div>
  );

  return (
    <Container>
      {header && (
        <HeaderSection>
            <Title>{header.title}</Title>
            <p style={{fontSize:'1.2rem', maxWidth:'800px', margin:'0 auto'}}>{header.description}</p>
            {header.image && (
                <div style={{height: '350px', marginTop: '2rem', borderRadius:'8px', overflow:'hidden', display:'flex', alignItems:'center', justifyContent:'center', background:'#f0f0f0'}}>
                    <img src={getImageUrl(header.image)} alt={header.title} style={{width:'100%', height:'100%', objectFit:'contain'}} />
                </div>
            )}
        </HeaderSection>
      )}

      <Grid>
        {posts.map(post => (
          <PostCard key={post._id}>
            <ImageContainer>
              {post.images && post.images.length > 0 ? (
                <LazyImage src={post.images[0]} alt={post.title} />
              ) : (
                <div style={{background:'#eee', width:'100%', height:'100%'}} />
              )}
            </ImageContainer>
            <Content>
              <PostTitle>{post.title}</PostTitle>
              <DateText>{new Date(post.createdAt).toLocaleDateString()}</DateText>
              <p style={{flex:1}}>{post.description.substring(0, 120)}...</p>
            </Content>
          </PostCard>
        ))}
      </Grid>
      
      {posts.length === 0 && <p style={{textAlign:'center'}}>No news posts yet.</p>}
    </Container>
  );
};

export default News;
